module.exports = {
	"_args": [
		[
			"@truffle/contract@4.1.0",
			"/vercel/path0"
		]
	],
	"_from": "@truffle/contract@4.1.0",
	"_id": "@truffle/contract@4.1.0",
	"_inBundle": false,
	"_integrity": "sha512-CVAv7rvRtt6dS9zUB3zrWkbV2RbwWxGbSOq/33NMHCj+Envt+G2a6NIAexYADk6zLhHhCc1K2/wH7HElM3CKcQ==",
	"_location": "/@truffle/contract",
	"_phantomChildren": {
		"@truffle/provider": "0.2.2",
		"@types/node": "10.14.7",
		"any-promise": "1.3.0",
		"bn.js": "4.11.8",
		"brorand": "1.1.0",
		"crypto-js": "3.1.9-1",
		"ethereum-bloom-filters": "1.0.6",
		"ethjs-unit": "0.1.6",
		"fast-json-stable-stringify": "2.0.0",
		"hmac-drbg": "1.0.1",
		"inherits": "2.0.3",
		"minimalistic-assert": "1.0.1",
		"minimalistic-crypto-utils": "1.0.1",
		"number-to-bn": "1.7.0",
		"safe-buffer": "5.1.2",
		"uri-js": "4.2.2",
		"web3-bzz": "1.2.2",
		"web3-core": "1.2.2",
		"web3-eth": "1.2.2",
		"web3-eth-personal": "1.2.2",
		"web3-net": "1.2.2",
		"web3-shh": "1.2.2",
		"xhr-request-promise": "0.1.2",
		"xmlhttprequest": "1.8.0"
	},
	"_requested": {
		"type": "version",
		"registry": true,
		"raw": "@truffle/contract@4.1.0",
		"name": "@truffle/contract",
		"escapedName": "@truffle%2fcontract",
		"scope": "@truffle",
		"rawSpec": "4.1.0",
		"saveSpec": null,
		"fetchSpec": "4.1.0"
	},
	"_requiredBy": [
		"/",
		"/openzeppelin-test-helpers"
	],
	"_resolved": "https://registry.npmjs.org/@truffle/contract/-/contract-4.1.0.tgz",
	"_spec": "4.1.0",
	"_where": "/vercel/path0",
	"author": {
		"name": "Tim Coulter",
		"email": "tim@trufflesuite.com"
	},
	"bugs": {
		"url": "https://github.com/trufflesuite/truffle/issues"
	},
	"dependencies": {
		"@truffle/blockchain-utils": "^0.0.15",
		"@truffle/contract-schema": "^3.0.19",
		"@truffle/error": "^0.0.8",
		"@truffle/interface-adapter": "^0.3.3",
		"bignumber.js": "^7.2.1",
		"ethereum-ens": "^0.7.7",
		"ethers": "^4.0.0-beta.1",
		"web3": "1.2.2",
		"web3-core-promievent": "1.2.2",
		"web3-eth-abi": "1.2.2",
		"web3-utils": "1.2.2"
	},
	"description": "A better contract abstraction for Ethereum (formerly EtherPudding)",
	"devDependencies": {
		"@truffle/compile-solidity": "^4.2.12",
		"async": "2.6.1",
		"browserify": "^14.0.0",
		"chai": "4.2.0",
		"debug": "^4.1.0",
		"ganache-core": "2.8.0",
		"mocha": "5.2.0",
		"sinon": "^7.3.2",
		"temp": "^0.8.3",
		"uglify-es": "^3.3.9"
	},
	"gitHead": "a962a994179f561ec8862abed747b18958dbf6ba",
	"homepage": "https://github.com/trufflesuite/truffle/tree/master/packages/contract#readme",
	"keywords": [
		"abstraction",
		"contract",
		"ethereum",
		"truffle"
	],
	"license": "MIT",
	"main": "index.js",
	"name": "@truffle/contract",
	"publishConfig": {
		"access": "public"
	},
	"repository": {
		"type": "git",
		"url": "https://github.com/trufflesuite/truffle/tree/master/packages/contract"
	},
	"scripts": {
		"compile": "mkdir -p dist && browserify ./index.js -o ./dist/truffle-contract.js && uglifyjs ./dist/truffle-contract.js -o ./dist/truffle-contract.min.js",
		"prepare": "yarn compile",
		"publish:next": "node ../truffle/scripts/prereleaseVersion.js next next",
		"test": "./scripts/test.sh",
		"test:debug": "$(yarn bin)/mocha --inspect-brk",
		"test:trace": "$(yarn bin)/mocha --trace-warnings"
	},
	"typings": "./typings/index.d.ts",
	"version": "4.1.0"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@truffle/contract/package.json
// module id = 1516
// module chunks = 0